<div class="wrapper">
  <div class="show-video-bg">
    <div class="video-wrapper">
      <video class="video-banner" loop="true" autoplay muted oncanplay="this.play()"
        onloadedmetadata="this.muted = true">
        <source src="./assets/videos/banner-video.mp4" type="video/mp4" />
      </video>
    </div>
    <div class="announcement-overlay">
      <div class="announcement-card" data-aos="fade-up">
        <p class="tagline">Titanium Comms is now Quanta</p>
        <h1 class="headline">Same Mission. Stronger Identity.</h1>
        <p class="subline">Built for the quantum era.</p>
        <p class="byline">QUANTA, BY TITANIUM SECURE SERVICES, LLC</p>
        <a href="https://www.quantasure.com" target="_blank" class="cta-btn">
          Visit Quanta &rarr;
        </a>
      </div>
    </div>
  </div>
</div>
